import { EVENTS } from '../../../bus/events.const';
import { COMPONENTS } from '../../../components/components.registry';
import { WindowEventBinderConfig } from '../../../models';

export const DEFAULT_WINDOW_EVENT_BINDER_CONFIG: WindowEventBinderConfig = {
  components: {
    windowEventBinder: COMPONENTS.PURE.WindowEventBinder
  },
  events: {
    resize: EVENTS.WindowSizeChanged,
    orientationchange: EVENTS.WindowSizeChanged,
    keyup: EVENTS.KeyUp,
    popstate: EVENTS.EmpathyXCreated
  }
};
